import { List } from 'antd';
import { TabPaneContainer } from '../styles';
import { Issue, QueryType } from '../../../../types';
import ToBeReviewItem from '../../../../components/toBeReviewItem';
import { useAppDispatch } from '../../../../store';
import { useRef, useState } from 'react';
import { fetchNotifications } from '../../../../slices/notifications';
import SuggestionReviewDrawer from '../../../../components/suggestionReviewDrawer';

const Issues = ({ issues }: { issues: Issue[] }) => {
  const dispatch = useAppDispatch();
  const [showReviewDrawer, setShowReviewDrawer] = useState(false);
  const currentItem = useRef<Issue>(null);

  const handleReviewDrawerClose = (isSubmitted?: boolean) => {
    setShowReviewDrawer(false);
    if (isSubmitted) {
      dispatch(fetchNotifications());
    }
  };
  return (
    <TabPaneContainer>
      <List
        pagination={false}
        dataSource={issues}
        renderItem={(item, index) => (
          <ToBeReviewItem
            name={item.templateName}
            description={item.name}
            onClick={() => {
              setShowReviewDrawer(true);
              currentItem.current = item;
            }}
          />
        )}
        // footer={
        //   issues?.length > 3 ? (
        //     <Flex align="center" justify="center">
        //       <Button type="text">Load more</Button>
        //     </Flex>
        //   ) : null
        // }
      />
      {currentItem.current && (
        <SuggestionReviewDrawer
          visible={showReviewDrawer}
          onClose={handleReviewDrawerClose}
          queryType={QueryType.ISSUE}
          data={currentItem.current as Issue}
        />
      )}
    </TabPaneContainer>
  );
};

export default Issues;
